export const createAuthorityRoute = '/marc-authorities/quick-marc/create-authority';
